import {Component, OnInit, AfterViewInit, ViewChild, ElementRef, ChangeDetectorRef} from '@angular/core';
import {Question} from "../question";
import {QuestionService} from "../question.service";
import {Quiz} from '../quiz';
import {QuizService} from '../quiz.service';
import {AuthService} from "../auth.service";
import {ActivatedRoute, Params, Router} from "@angular/router";

import {Observable} from "rxjs/Observable";

import * as lodash from "lodash";

declare var PDFDocument: any;
declare var QRCode: any;
declare var blobStream: any;

@Component({
  selector: 'app-questions-table',
  templateUrl: './questions-table.component.html',
  styleUrls: ['./questions-table.component.css']
})
export class QuestionsTableComponent implements OnInit, AfterViewInit {
  public questions: Question[] = [];
  public quizzes: Quiz[] = [];
  public activeQuestion: Question = null;
  public activeQuiz: Quiz = null;
  public showSV: boolean = false;
  public pdfCreated: boolean = false;
  @ViewChild('pdfelement') pdfelement: ElementRef;

  constructor(private questionService: QuestionService,
              private quizService: QuizService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router,
              private ref: ChangeDetectorRef) {}

  ngOnInit() {
    this.quizService.quizzes$.combineLatest(this.route.params, this.questionService.questions$).subscribe(([quizzes, params, questions]) => {
      this.quizzes = quizzes;
      const quizID = (params as any).quizID;

      if (!quizID || quizzes.length === 0) {
        this.activeQuiz = undefined;

        return;
      }

      this.activeQuiz = this.quizzes.find(quiz => quiz._id === quizID);

      // this.questions = lodash.intersectionBy(this.questions, this.activeQuiz.questionArray, e => {
      //   if (typeof e === "string") {
      //     return e;
      //   } else if (typeof e === "object") {
      //     return e._id;
      //   }
      // });

      let filteredQuestions = [];

      for (let question of questions){
        if (this.activeQuiz.questionArray.includes(question._id)) {
          filteredQuestions.push(question);
        }
      }

      questions = filteredQuestions;

      this.questions = questions.sort((a, b) =>  a.ordinal - b.ordinal);



    });
  }

  ngAfterViewInit() {
    // console.log(this.pdfelement.nativeElement.value);
  }

  loadPDF() {
    let document: any = new PDFDocument({
      size: [595, 842],
      margins: {
        top: 40,
        bottom: 20,
        left: 40,
        right: 40
      }
    });
    let qrcode2 = new QRCode(null, {
      width: 400,
      height: 400
    });
    let stream = document.pipe(blobStream());

    for (let q of this.questions) {

      document.fontSize(30)
        .text(this.cleanText(this.activeQuiz.quizName_fi),
          {
            align: 'center'
          }
        )
        .fontSize(20)
        .text('' + this.cleanText(q.ordinal),
          {
            align: 'center'
          }
        )
        .moveDown()
        .fontSize(20)
        .text(this.cleanText(q.questionLabel_fi),
          {
            align: 'center'
          }
        )
        .text(this.cleanText(q.questionLabel_sv),
          {
            align: 'center'
          }
        )
        .moveDown()

      let centerX = (595 - 400) / 2;
      let imgUri = qrcode2.getBase64ImageSrc(q.code);
      document.image(imgUri, centerX);
      document.moveDown()
        .fontSize(100)
        .text(q.code, {
          align: 'center'
        });
      if (this.questions.indexOf(q) != this.questions.length - 1) {
        document.addPage();
      }
    }

    document.end();
    stream.on('finish', () => {
      let blob = stream.toBlob('application/pdf');

      //let url = stream.toBlobURL('application/pdf');
      console.log("PDF is", blob);

      let saveData = (blob: Blob, fileName: string) => {
        console.log("this pdf element", this.pdfelement);
        let url = URL.createObjectURL(blob);
        this.pdfelement.nativeElement.href = url;
        this.pdfelement.nativeElement.download = fileName;
        this.pdfelement.nativeElement.style = "visibility: visible";
        this.pdfCreated = true;

      };
      saveData(blob, "code.pdf");
    });
  }

  loadPDFNoQR() {
    let document: any = new PDFDocument({
      size: [595, 842],
      margins: {
        top: 40,
        bottom: 20,
        left: 40,
        right: 40
      }
    });

    let stream = document.pipe(blobStream());

    for (let q of this.questions) {

      document.fontSize(30)
        .text(this.cleanText(this.activeQuiz.quizName_fi),
          {
            align: 'center'
          }
        )
        .fontSize(20)
        .text('' + this.cleanText(q.ordinal),
          {
            align: 'center'
          }
        )

      document.moveDown()
        .fontSize(25)
        .text(this.cleanText(q.questionLabel_fi),
          {
            align: 'center'
          }
        )
        .fontSize(20)
        .text(this.getPdfAnswerString(q, 0), {
          align: 'center'
        });
      document.moveDown()
        .fontSize(25)
        .text(this.cleanText(q.questionLabel_sv),
          {
            align: 'center'
          }
        )
        .fontSize(20)
        .text(this.getPdfAnswerString(q, 1), {
          align: 'center'
        });
      document.moveDown()
        .fontSize(25)
        .text(this.cleanText(q.questionLabel_en),
          {
            align: 'center'
          }
        )
        .fontSize(20)
        .text(this.getPdfAnswerString(q, 2), {
          align: 'center'
        });
      if (this.questions.indexOf(q) != this.questions.length - 1) {
        document.addPage();
      }
    }

    document.end();
    stream.on('finish', () => {
      let blob = stream.toBlob('application/pdf');

      //let url = stream.toBlobURL('application/pdf');
      console.log("PDF is", blob);

      let saveData = (blob: Blob, fileName: string) => {
        console.log("this pdf element", this.pdfelement);
        let url = URL.createObjectURL(blob);
        this.pdfelement.nativeElement.href = url;
        this.pdfelement.nativeElement.download = fileName;
        this.pdfelement.nativeElement.style = "visibility: visible";
        this.pdfCreated = true;

      };
      saveData(blob, "questions.pdf");
    });
  }


  protected getAnswerString(question: Question): string {
    let result = "";
    if (question.answerArray.length === 0) {
      result = "Ei vastauksia";
    }
    else {
      for (let index in question.answerArray) {
        result += "" + (+index + 1 ) + ": " + question.answerArray[index].answerLabel_fi + " (" + question.answerArray[index].score + " pistettä)<br />";
      }
    }
    return result;
  }

  protected getPdfAnswerString(question: Question, language: number): string {
    let result = "";
    if (question.answerArray.length === 0) {
      result = "Ei vastauksia";
    }
    else {
      if (language === 0) {
        for (let index in question.answerArray) {
          if (this.cleanText(question.answerArray[index].answerLabel_fi) !== "") {
            result += "" + (+index + 1 ) + ": " + this.cleanText(question.answerArray[index].answerLabel_fi) + "\n";
          }
        }
      }
      if (language === 1) {
        for (let index in question.answerArray) {
          if (this.cleanText(question.answerArray[index].answerLabel_sv) !== "") {
            result += "" + (+index + 1 ) + ": " + this.cleanText(question.answerArray[index].answerLabel_sv) + "\n";
          }
        }
      }
      if (language === 2) {
        for (let index in question.answerArray) {
          if (this.cleanText(question.answerArray[index].answerLabel_en) !== "") {
            result += "" + (+index + 1 ) + ": " + this.cleanText(question.answerArray[index].answerLabel_en) + "\n";
          }
        }
      }
    }
    return result;
  }

  remove(question: Question): void {
      const r: boolean = confirm("Haluatko varmasti poistaa pysyvästi kysymyksen " + question.questionLabel_fi);
      if (r === true) {
        for (let i = 0; i < this.activeQuiz.questionArray.length; i++) {
          if (question._id === this.activeQuiz.questionArray[i].toString()) {
            this.activeQuiz.questionArray.splice(i, 1);
            console.log('Kysymys visan indeksissä ' + i + ' poistettu.');
            this.quizService.updateQuiz(this.activeQuiz).subscribe(res => {
              if (res) {
                //alert('Kysymyksen poisto visasta onnistui!');
                this.quizService.loadQuizList();
                //this.questionService.loadQuestionList();
              }
              else {
                //alert('Kysymyksen poisto visasta epäonnistui!');
                console.error("Virhe positettaessa kysymystä visasta!");
              }
            });
          }
        }
        this.questionService.removeQuestion(question._id).subscribe(res => {
          if (res) {
            alert("Kysymyksen poisto onnistui!");
          }
          else {
            alert("Kysymyksen poisto epäonnistui!");
          }
        });
      } else {
        //do nothing
      }
    //}
  }

  addNewQuestion(): void {
    this.activeQuestion = new Question();
    this.activeQuestion.answerAmount = 1;
    this.activeQuestion.answerArray = [];
    this.setRandomCode(this.activeQuestion);
    this.activeQuestion.ordinal = this.questions.length + 1;
    this.activeQuestion.timeLimitSeconds = 30;
  }

  randomString(length: number, chars: string): string {
    var result = '';
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
  }

  setRandomCode(question: Question) {
    question.code = this.randomString(this.authService.currentAdmin$.value.settings.codeLenght, '23456789ABCDEFGHJKLMNPQRSTUVWXYZ'); //abcdefghijkmnopqrstuvwxyz
  }

  getMaxPoints(question: Question): string {
    if (question.answerArray.length == 0) {
      return "--";
    }
    let maxScore = question.answerArray[0].score;
    for (let answer of question.answerArray) {
      maxScore = Math.max(maxScore, answer.score);
    }
    return "" + maxScore;
  }

  removeAnswer(question: Question, answer: number): void {
    question.answerArray.splice(answer, 1);
  }

  addNewAnswer(question: Question): void {
    question.answerArray.push({answerLabel_fi: "", answerLabel_en: "", answerLabel_sv: "", score: 0});
  }

  save(question: Question) {
    if (this.checkForSameCodes(question)) {
      if (question._id) {
        this.questionService.updateQuestion(question)
          .subscribe(
            res => {
              if (res) {
                this.activeQuestion = null;
                alert("Kysymyksen tallennus onnistui!");
              } else {
                alert("Kysymyksen tallennus epäonnistui!");
              }
            },
            err => {
              alert("Kysymyksen tallennus epäonnistui pahasti!");
            }
          );
      } else {
        this.questionService.addQuestion(question, this.activeQuiz)
          .subscribe(
            res => {
              if (res) {
                this.activeQuestion = null;
                alert("Uuden kysymyksen luonti onnistui!");
                this.quizService.loadQuizList();
                this.questionService.loadQuestionList();
              } else {
                alert("Uuden kysymyksen luonti epäonnistui!");
              }
            },
            err => {
              alert("Uuden kysymykset luonti pahasti!");
              console.error(err);
            });
      }
    }
  }

  saveQuiz(quiz: Quiz) {
    if (this.checkForSameCodesQuiz(quiz)) {
      if (quiz._id) {
        this.quizService.updateQuiz(quiz)
          .subscribe(
            res => {
              if (res) {
                // this.activeQuiz = null;
                alert("Visan tallennus onnistui!");
                // window.location.href = '/admin/quizzes/';
              }
              else {
                alert("Visan tallennus epäonnistui!");
              }
            },
            err => {
              alert("Visan tallennus epäonnistui pahasti!");
            }
          );
      }
      else {
        this.quizService.addQuiz(quiz)
          .subscribe(
            res => {
              if (res) {
                this.activeQuiz = null;
                alert("Uuden visan luonti onnistui!");
              }
              else {
                alert("Uuden visan luonti epäonnistui!");
              }
            },
            err => {
              alert("Uuden visan luonti epäonnistui pahasti!");
              console.error(err);
            });
      }
    }
  }

  get diagnostic(): string {
    return JSON.stringify(this.activeQuestion);
  }

  edit(question: Question) {
    this.activeQuestion = question;
  }

  cancel() {
    this.questionService.loadQuestionList();
    this.activeQuestion = null;
  }

  cancelQuiz() {
    this.quizService.loadQuizList();
    // this.activeQuiz = null;
    // window.location.href = '/admin/quizzes/';
  }

  showSwedish() {
    this.showSV = !this.showSV;
  }

  changeAnswerLimitType(question: Question) {
    if (question.answerAmount == 0) {
      question.answerAmount = -1;
    }
    else {
      question.answerAmount = -question.answerAmount;
    }
  }

  transferQuestiontoQuiz2(question: Question, quiz: Quiz) {
    this.questionService.copyQuestion(question, quiz);
    this.quizService.loadQuizList();
    this.questionService.loadQuestionList();
  }


  /*transferQuestiontoQuiz(question: Question, quiz: Quiz) {
    for (let i = 0; i < quiz.questionArray.length; i++) {
      if (question._id === quiz.questionArray[i].toString()) {
        alert('Kysymys on jo visassa!');
        return;
      }
    }
    quiz.questionArray.push({questionID: question._id});
    this.quizService.updateQuiz(quiz)
      .subscribe(
        res => {
          if (res) {
            alert('Kysymys on siirretty visaan ' + quiz.quizName_fi + '!');
          }
          else {
            alert('Kysymyksen siirtäminen epäonnistui!');
          }
        },
        err => {
          alert('Kysymyksen siirtäminen epäonnistui!');
          console.error(err);
        });
  }*/

  cleanText(text: any): string {
    if (!text) {
      return "";
    }
    return text;
  }

  checkForSameCodes(question: Question): boolean {
      let counter = 0;
      for (let i = 0; i < this.questions.length; i++) {
        if (this.questions[i].code.toUpperCase() === question.code.toUpperCase()) {
          counter++;
        }
      }
      if (question._id) {
        if (counter > 1) {
          const r: boolean = confirm("VAROITUS: Visassa on jo olemassa kysymys samalla avauskoodilla! Haluatko varmasti jatkaa?");
          if (r === true) {
            return true;
          }
          return false;
        }
      } else {
        if (counter > 0) {
          const r: boolean = confirm("VAROITUS: Visassa on jo olemassa kysymys samalla avauskoodilla! Haluatko varmasti jatkaa?");
          if (r === true) {
            return true;
          }
          return false;
        }
      }
    return true;
  }
  checkForSameCodesQuiz(quiz: Quiz): boolean {
    if (quiz.joinToken !== "") {
      let counter = 0;
      for (let i = 0; i < this.quizzes.length; i++) {
        if (this.quizzes[i].joinToken.toUpperCase() === quiz.joinToken.toUpperCase()) {
          counter++;
        }
      }
      if (quiz._id) {
        if (counter > 1) {
          const r: boolean = confirm("VAROITUS: Toisessa visassa sama liittymiskoodi! Haluatko varmasti jatkaa?");
          if (r === true) {
            return true;
          }
          return false;
        }
      } else {
        if (counter > 0) {
          const r: boolean = confirm("VAROITUS: Toisessa visassa sama liittymiskoodi! Haluatko varmasti jatkaa?");
          if (r === true) {
            return true;
          }
          return false;
        }
      }
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/questions-table/questions-table.component.ts